import React, { useEffect, useState } from 'react';
import { QRCode } from 'antd';
import styles from './RegionContactList.module.scss';
import Modal from '@/components/modal/Modal';

const RegionContactList = () => {
  const [visible, setVisible] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [personData, setPersonData] = useState([]);
  useEffect(() => {
    const getPersonData = async () => {
      try {
        let response = await fetch(
          'https://oss.zmrobo.com/zmrobo/update/contact.json',
        );
        let data = await response.json();
        setPersonData(data);
      } catch (error) {
        console.error('获取联系人数据失败:', error);
      }
    };
    getPersonData();
  }, []);
  const groupByArea = (contacts) => {
    const grouped = {};
    contacts.forEach((contact) => {
      if (!grouped[contact.area]) {
        grouped[contact.area] = [];
      }
      grouped[contact.area].push(contact);
    });
    return grouped;
  };

  const handleContactClick = (contact) => {
    setSelectedContact(contact);
    setVisible(true);
  };

  const handleModalClose = () => {
    console.log('showContactModal');
    setVisible(false);
    setSelectedContact(null);
  };

  const groupedData = groupByArea(personData);
  const areaKeys = Object.keys(groupedData);

  // 将区域按两个一组进行分组
  const groupedAreas = [];
  for (let i = 0; i < areaKeys.length; i += 2) {
    groupedAreas.push(areaKeys.slice(i, i + 2));
  }

  return (
    <div className={styles.box}>
      <div className={styles.regionContainer}>
        <div className={styles.title}>
          <span>联系我们</span>
        </div>
        {groupedAreas.map((areaGroup, groupIndex) => (
          <div key={groupIndex} className={styles.areaRow}>
            {areaGroup.map((area) => (
              <div key={area} className={styles.areaSection}>
                <div className={styles.areaTitle}>{area}</div>
                <div className={styles.contactList}>
                  {groupedData[area].map((contact, index) => (
                    <div key={index} className={styles.contactItem}>
                      <span className={styles.region}>{contact.region}</span>
                      <span
                        className={styles.name}
                        onClick={() => handleContactClick(contact)}
                      >
                        {contact.name}
                      </span>
                      <span className={styles.phone}>{contact.phone}</span>
                      <span
                        className={styles.name}
                        onClick={() => handleContactClick(contact)}
                      >
                        加我微信
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <Modal
        width={600}
        contentClassName="p-20 flex justify-center align-center"
        visible={visible}
        showFooter={false}
        title={
          selectedContact
            ? `${selectedContact.area} - ${selectedContact.name}`
            : '联系人'
        }
        onCancel={handleModalClose}
      >
        <div className={styles.idCard}>
          <div className={styles.idCardLeft}>
            <div className={styles.name}>{selectedContact?.name}</div>
            <div className={styles.position}>{selectedContact?.job || ''}</div>
            <div className={styles.contactInfo}>
              {selectedContact?.phone && (
                <div className={styles.phoneGroup}>
                  <span className={styles.phone}>{selectedContact.phone}</span>
                </div>
              )}
              {selectedContact?.phone2 && (
                <div className={styles.phoneGroup}>
                  <span className={styles.phone}>{selectedContact.phone2}</span>
                </div>
              )}
              {selectedContact?.address && (
                <div className={styles.addressGroup}>
                  <span className={styles.address}>
                    {selectedContact.address}
                  </span>
                </div>
              )}
              {selectedContact?.email && (
                <div className={styles.emailGroup}>
                  <span className={styles.email}>{selectedContact.email}</span>
                </div>
              )}
            </div>
          </div>
          <div className={styles.idCardRight}>
            <div className={styles.qrCode}>
              {selectedContact?.qrData ? (
                <QRCode
                  value={selectedContact.qrData}
                  size={120}
                  style={{ marginTop: 12, marginBottom: 8 }}
                />
              ) : selectedContact?.url ? (
                <img
                  src={selectedContact.url}
                  alt="WeChat QR Code"
                  style={{ width: 120, height: 120, marginBottom: 8 }}
                />
              ) : null}
              <div className={styles.qrLabel}>WeChat</div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default RegionContactList;
